<template>
  <div id="promotion">
    <template>
      <div class="top-section">
        <div class="title-wapper">我的佣金</div>
        <div class="total-box">
          <div class="amount-wapper">
            <div class="amount-font">我的预估佣金(元)</div>
            <div class="amount-number">1088.91</div>
          </div>
          <div class="btn-wapper" @click="openExplainPop()">
            <van-button size="small">佣金说明</van-button>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <p>提现记录</p>
        <div class="cash-wapper">
          <div class="cash-item" v-for="(item, i) in 3" :key='i'>
            <div class="cash-detail">
              <div class="already-cash">已提现500元</div>
              <div class="time">2023-08-09  13:09:45</div>
            </div>
            <div class="cash-amount">￥500.00</div>
          </div>
        </div>
      </div>
    </template>
    <van-popup v-model="showExplainPop" :style="{ width:'95%'}" closeable>
      <div class="description-pop">
        <p class="title-font">佣金说明</p>
        <div class="description-line">
          <div class="description-line-top">
            <van-image width="16" height="17" :src="countImg" />
            <span>预估佣金算法说明</span>
          </div>
          <p>1）预估佣金算法说明预估佣金算法说明预估佣金算法说明预估佣金算法说明预估佣金算法说明预估佣金算法说明预估佣金算法说明预估佣金算</p>
        </div>
        <div class="description-line">
          <div class="description-line-top">
            <van-image width="16" height="16" :src="wayImg" />
            <span>预估佣金提现方式说明</span>
          </div>
          <p>1）预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金提现方式说明预估佣金。</p>
        </div>
        <div class="description-line">
          <div class="description-line-top">
            <van-image width="16" height="16" :src="phoneImg" />
            <span>联系方式：028-22334455</span>
           </div>
        </div>
        <div class="btn-wapper" @click="getKnow()">
          <van-button class="know-btn" size="normal">知道了</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showExplainPop: false,
      countImg: require("../../../assets/login/count.png"),
      wayImg: require("../../../assets/login/way.png"),
      phoneImg: require("../../../assets/login/phone.png")
    }
  },
  created () {
    //12
  },
  methods: {
    openExplainPop() {
      this.showExplainPop = true
    },
    getKnow() {
      this.showExplainPop = false
    }
  }
}
</script>

<style lang="less">
/deep/.van-icon {
  color: #fff;
}
</style>
<style lang="less" scoped>
@import "~@/styles/variable.less";

#promotion {
  .top-section {
    padding: 0 20px;
    background-image: url(../../../assets/login/yongjin.png);
    height: 150px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    /deep/.van-button--default {
      color: #FD652D;
    }
    
    .title-wapper {
      text-align: center;
      color: #FFFFFF;
      padding: 15px 0;
      font-size: 16px;
    }
    .total-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .amount-wapper {
        color: #FFFFFF;
        .amount-font {
          font-size: 14px;
        }
        .amount-number {
          font-size: 26px;
          margin-top:5px;
        }
      }
    }
  }
  .bottom-section {
    background-color: #F7F8F9;
    height: 300px;
    /deep/.van-overlay {
      border: 1px solid #ddd;
    }
    p {
      text-align: center;
      padding: 10px 0;
      color: #000000;
      font-size: 16px;
    }
    .cash-wapper {
      border-radius: 5px;
      background-color: #fff;
      margin: 0px 15px;
      padding: 10px;
      .cash-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #EFEFEF;
        margin-bottom: 10px;
        .already-cash {
          color: #000000;
          margin: 5px 0 3px 0;
        }
        .time {
          color: #999999;
        }
        .cash-amount {
          color: #F82859;
        }
      }
    }
  }
  .description-pop {
    padding: 15px 20px;
    .title-font {
      text-align: center;
      color: black;
      padding: 0px 0 16px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .description-line {
      margin: 0 0 10px 0;
      p {
        color: #7F7F7F;
      }
      .description-line-top {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        span {
          margin-left: 5px;
          color: #272727;
          font-size: 15px;
        }
      }
    }
    .btn-wapper {
      text-align: center;
      margin-top: 20px;
      .know-btn {
        border-radius: 50px;
        width: 60%;
        background-color: #FF7A4A;
        color: #fff;
      }
    }
  }
}
</style>